<template>
  <component-wrapper
    :key="catalogId"
    class="product-detail-page-fi product-detail-page-fite-fi"
  >
    <product-detail-head-fite-fi
      :catalog-data="getCatalogProductDataById"
      :media-download-link="mediaDownloadLink"
      :fields="fields"
      :no-margin-bottom="Boolean(accessories?.length)"
    />

    <product-items-slider-fi
      v-if="accessories?.length"
      :product-items="accessories"
      :slider-headline="$dict.get('product-Family.Accessories.Headline-Fite')"
      white
      expandable
    />

    <product-detail-accordions-fi
      :fields="fields"
      :catalog-data="getCatalogProductDataById"
    />

    <section-divider-small-fi />

    <product-items-slider-fi
      v-if="hasMandatoryAccessories"
      :product-items="mandatoryAccessories"
      :slider-headline="$dict.get('product-Family.Accessories-Mandatory.Headline')"
      is-light
    />

    <product-detail-schema-fi
      v-if="getCatalogProductDataById"
      :catalog-data="getCatalogProductDataById"
    />
  </component-wrapper>
</template>

<script>
import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import ProductDetailAccordionsFi from '@/components/product-detail/product-detail-accordions-fi/ProductDetailAccordionsFi.vue';
import ProductDetailHeadFiteFi from '@/components/product-detail/product-detail-head-fi/ProductDetailHeadFiteFi.vue';
import ProductDetailSchemaFi from '@/components/product-detail/product-detail-schema-fi/ProductDetailSchemaFi.vue';
import ProductItemsSliderFi from '@/components/product-items-slider-fi/ProductItemsSliderFi.vue';
import GET_CATALOG_PRODUCT_DATA_BY_ID from '@/graphql/getCatalogProductDataById.gql';
import breakpointMixin from '@/mixins/breakpointMixin.vue';
import catalogMixin from '@/mixins/catalogMixin.vue';
import SectionDividerSmallFi from '@/pages/section-divider-fi/SectionDividerSmallFi.vue';

export default {
  name: 'ProductDetailPageFiteFi',
  components: {
    ComponentWrapper,
    ProductDetailHeadFiteFi,
    ProductDetailAccordionsFi,
    SectionDividerSmallFi,
    ProductItemsSliderFi,
    ProductDetailSchemaFi,
  },
  mixins: [breakpointMixin, catalogMixin],
  inject: ['fields'],
  data() {
    return {
      getCatalogProductDataById: {},
    };
  },
  computed: {
    catalogId() {
      return this.$fischer.catalogId('559879');
    },
    accessories() {
      return this.getCatalogProductDataById?.accessories;
    },
    mandatoryAccessories() {
      return this.getCatalogProductDataById?.mandatoryAccessories;
    },
    hasMandatoryAccessories() {
      return this.mandatoryAccessories?.length;
    },
  },
  created() {
    if (this.catalogId) {
      this.checkForMediaDownload({
        type: 'product',
        id: this.catalogId,
      });
    }
  },
  apollo: {
    getCatalogProductDataById: {
      query: GET_CATALOG_PRODUCT_DATA_BY_ID,
      errorPolicy: 'all',
      variables() {
        return {
          baseSiteId: this.$fischer.baseSiteId(),
          apiLang: this.$fischer.catalogLocale(),
          id: this.catalogId,
          getMandatoryAccessories: true,
        };
      },
      skip() {
        return !this.$fischer.catalogId;
      },
      error() {
        this.error = true;
      },
    },
  },
};
</script>
